/**
 * IngredientPhysicalKind - synchronized with the Prisma enum of the same name.
 *
 * Drives the weighted-order rule of art. 18 §1: WATER and VOLATILE rows sort
 * by their weight in the finished product, not by weight at time of use
 * (Annex VII Part A, point 1).
 */
export const INGREDIENT_PHYSICAL_KINDS = ['STANDARD', 'WATER', 'VOLATILE'] as const;
export type IngredientPhysicalKind = (typeof INGREDIENT_PHYSICAL_KINDS)[number];
